<template>
  <div>


    <div class="container">
      <h1 class="titulo m-y-1-sm m-t-3-md m-b-1-md">Estadísticas Generales</h1>
      <Tablero class="m-t-1" />
    </div>

    <div class="container m-y-2">
      <div class="texto-notas">
        <p><strong>Notas</strong></p>
        <p>
          Las abreviaturas "cis" y "trans" corresponden a las identidades de
          género Cisgénero y Transgénero respectivamente con la que cada
          participante se identificó al responder la encuesta.
        </p>
        <p>
          Las categorías "Seguro Popular" y “Sin seguridad” se homologaron a la categoría "INSABI".
          Ya que las personas participantes que tienen estas categorías, por derecho, pueden recibir
          servicios de salud por parte del Instituto de Salud para el Bienestar (INSABI).
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Tablero from "@/components/vih/Tablero.vue";
import { mapState } from "vuex";

export default {
  name: "Estadistica",
  components: {    
    Tablero,
  },
  data() {
    return {
      domain: process.env.VUE_APP_ENI_DOMAIN,
      base_route: process.env.VUE_APP_BASE_ROUTE,
      public_path: process.env.BASE_URL
    };
  },
  computed: {
    ...mapState(["numero_nodos_clusters", "nodos_totales"]),
    obtenerNombreEni() {
      return this.$store.getters.obtenerNombreEni;
    },
    vistaSimplificada() {
      return this.$store.getters.tieneVistaSimplificada;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
